/* Fuentes Distribution — mega menú de escritorio y panel lateral móvil */
(function () {
  var HOVER_OPEN = 80;
  var HOVER_CLOSE = 220;
  var canHover = window.matchMedia('(hover: hover) and (pointer: fine)');

  class FdMegaNav extends HTMLElement {
    connectedCallback() {
      if (this._ac) return;
      this._ac = new AbortController();
      var signal = this._ac.signal;
      this._items = Array.from(this.querySelectorAll('[data-fd-item]'));
      this._timer = null;

      this._items.forEach((item) => {
        var trigger = item.querySelector('[data-fd-trigger]');
        var panel = item.querySelector('[data-fd-panel]');
        if (!trigger || !panel) return;

        trigger.addEventListener('click', (e) => {
          e.preventDefault();
          this.isOpen(item) ? this.close(item) : this.open(item);
        }, { signal });

        trigger.addEventListener('keydown', (e) => {
          if (e.key === 'ArrowDown') {
            e.preventDefault();
            this.open(item);
            var first = panel.querySelector('[data-fd-cat]');
            if (first) first.focus();
          }
        }, { signal });

        item.addEventListener('pointerenter', (e) => {
          if (e.pointerType !== 'mouse' || !canHover.matches) return;
          clearTimeout(this._timer);
          this._timer = setTimeout(() => this.open(item), this.current ? 0 : HOVER_OPEN);
        }, { signal });

        item.addEventListener('pointerleave', (e) => {
          if (e.pointerType !== 'mouse' || !canHover.matches) return;
          clearTimeout(this._timer);
          this._timer = setTimeout(() => this.close(item), HOVER_CLOSE);
        }, { signal });

        var cats = Array.from(panel.querySelectorAll('[data-fd-cat]'));
        cats.forEach((cat, i) => {
          cat.addEventListener('pointerenter', () => this.activate(panel, cat), { signal });
          cat.addEventListener('focus', () => this.activate(panel, cat), { signal });
          cat.addEventListener('keydown', (e) => {
            if (e.key === 'ArrowDown' || e.key === 'ArrowUp') {
              e.preventDefault();
              var next = cats[(i + (e.key === 'ArrowDown' ? 1 : -1) + cats.length) % cats.length];
              next.focus();
            }
          }, { signal });
        });

        item.addEventListener('focusout', (e) => {
          if (e.relatedTarget && !item.contains(e.relatedTarget)) this.close(item);
        }, { signal });
      });

      document.addEventListener('keydown', (e) => {
        if (e.key !== 'Escape' || !this.current) return;
        var item = this.current;
        this.close(item);
        var t = item.querySelector('[data-fd-trigger]');
        if (t) t.focus();
      }, { signal });

      document.addEventListener('pointerdown', (e) => {
        if (this.current && !this.current.contains(e.target)) this.close(this.current);
      }, { signal });

      window.addEventListener('resize', () => { if (this.current) this.close(this.current); }, { signal, passive: true });
    }

    disconnectedCallback() {
      clearTimeout(this._timer);
      if (this._ac) this._ac.abort();
      this._ac = null;
    }

    isOpen(item) {
      return item.classList.contains('is-open');
    }

    open(item) {
      if (this.current && this.current !== item) this.close(this.current, true);
      var trigger = item.querySelector('[data-fd-trigger]');
      var panel = item.querySelector('[data-fd-panel]');
      panel.hidden = false;
      item.classList.add('is-open');
      trigger.setAttribute('aria-expanded', 'true');
      this.classList.add('has-open');
      this.current = item;
    }

    close(item, instant) {
      var trigger = item.querySelector('[data-fd-trigger]');
      var panel = item.querySelector('[data-fd-panel]');
      item.classList.remove('is-open');
      trigger.setAttribute('aria-expanded', 'false');
      panel.hidden = true;
      if (this.current === item) {
        this.current = null;
        if (!instant) this.classList.remove('has-open');
      }
    }

    activate(panel, cat) {
      var idx = cat.getAttribute('data-fd-cat');
      panel.querySelectorAll('[data-fd-cat]').forEach((c) => c.classList.toggle('is-active', c === cat));
      panel.querySelectorAll('[data-fd-pane]').forEach((p) => {
        var on = p.getAttribute('data-fd-pane') === idx;
        p.hidden = !on;
        p.classList.toggle('is-active', on);
      });
    }
  }

  if (!customElements.get('fd-mega-nav')) customElements.define('fd-mega-nav', FdMegaNav);

  /* Panel lateral móvil con <dialog> nativo: foco atrapado y Escape incluidos */
  document.addEventListener('click', function (e) {
    var openBtn = e.target.closest('[data-fd-drawer-open]');
    if (openBtn) {
      var dlg = document.getElementById(openBtn.getAttribute('aria-controls'));
      if (dlg && typeof dlg.showModal === 'function') {
        dlg.showModal();
        openBtn.setAttribute('aria-expanded', 'true');
        document.documentElement.classList.add('fd-scroll-lock');
      }
      return;
    }
    if (e.target.closest('[data-fd-drawer-close]')) {
      closeDrawer(e.target.closest('dialog'));
      return;
    }
    if (e.target.matches('dialog.fd-drawer')) {
      var r = e.target.getBoundingClientRect();
      var inside = e.clientX >= r.left && e.clientX <= r.right && e.clientY >= r.top && e.clientY <= r.bottom;
      if (!inside) closeDrawer(e.target);
    }
  });

  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Escape') return;
    var open = document.querySelector('dialog.fd-drawer[open]');
    if (open) {
      e.preventDefault();
      closeDrawer(open);
    }
  });

  /* Cierra el panel y restaura estado de forma idempotente (no depende solo del evento 'close') */
  function closeDrawer(dlg) {
    if (!dlg) return;
    if (dlg.open) dlg.close();
    resetDrawer(dlg);
  }

  function resetDrawer(dlg) {
    document.documentElement.classList.remove('fd-scroll-lock');
    var btn = document.querySelector('[data-fd-drawer-open][aria-controls="' + dlg.id + '"]');
    if (btn && btn.getAttribute('aria-expanded') === 'true') {
      btn.setAttribute('aria-expanded', 'false');
      btn.focus();
    }
  }

  /* 'close' no burbujea: se escucha en captura para cubrir Escape, botón y clic en el fondo */
  document.addEventListener('close', function (e) {
    var dlg = e.target;
    if (!(dlg instanceof HTMLDialogElement) || !dlg.classList.contains('fd-drawer')) return;
    resetDrawer(dlg);
  }, true);
})();
